module.exports = __webpack_public_path__ + "static/media/sistema.980f27df.pdf";